var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87999 0.288115L5.99999 4.16811L2.11999 0.288115C2.02741 0.195533 1.9175 0.122093 1.79653 0.0719881C1.67557 0.0218831 1.54592 -0.00390625 1.41499 -0.00390625C1.28406 -0.00390625 1.15441 0.0218831 1.03345 0.0719881C0.912482 0.122093 0.802571 0.195533 0.70999 0.288115C0.617408 0.380696 0.543968 0.490607 0.493863 0.611571C0.443758 0.732535 0.417969 0.862184 0.417969 0.993114C0.417969 1.12405 0.443758 1.25369 0.493863 1.37466C0.543968 1.49562 0.617408 1.60553 0.70999 1.69811L5.29999 6.28811C5.68999 6.67811 6.31999 6.67811 6.70999 6.28811L11.3 1.69811C11.3927 1.6056 11.4662 1.49571 11.5164 1.37474C11.5666 1.25377 11.5924 1.12408 11.5924 0.993114C11.5924 0.862146 11.5666 0.732464 11.5164 0.61149C11.4662 0.490517 11.3927 0.380628 11.3 0.288115C10.91 -0.0918854 10.27 -0.101885 9.87999 0.288115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.13e979c10e11308b7e3fce8f0fb9a531.svg";
export { ForwardRef as ReactComponent };